import {
  getProductProperty,
  setCurrentSelectedProductVariant,
} from './getProductJSON';

export async function initVariantSelectChangeEventDispatcher(): Promise<void> {
  const variantSelectElement = document.querySelector(
    '.product-form__input.select.select--single'
  );

  if (!(variantSelectElement instanceof HTMLSelectElement)) {
    return;
  }

  maybeUpdateStoredVariantState(getProductProperty('current_variant'));

  const variantSelectChange = new CustomEvent('variantSelectChange', {
    detail: variantSelectElement,
    bubbles: true,
    cancelable: false,
    composed: false,
  });

  variantSelectElement.addEventListener('change', (el) => {
    if (!el || !(el.target instanceof HTMLSelectElement)) {
      return;
    }

    setTimeout(() => {
      if (el.target) {
        el.target.dispatchEvent(variantSelectChange);
      }
    }, 50);
  });
  variantSelectElement.addEventListener(
    'variantSelectChange',
    (event: CustomEventInit) => {
      if (event.detail && event.detail.value) {
        maybeUpdateStoredVariantState(event.detail.value);
      }
    }
  );
}

const maybeUpdateStoredVariantState = (variantID: string): void => {
  const productVariants: Record<string, any>[] = getProductProperty('variants');
  if (!productVariants || !Array.isArray(productVariants)) {
    return;
  }
  productVariants.forEach((variant) => {
    if (variant.title === variantID) {
      setCurrentSelectedProductVariant(variant.id);
    }
  });
};

export const maybeUpdateSingleSelectOptions = (
  value: string,
  name: string,
  overrideValue = false
): void => {
  const select = document.querySelector(
    `.product-form__input.select.select--single[name=${name}]`
  );

  if (!(select instanceof HTMLSelectElement)) {
    return;
  }

  const selectOptions = Array.from(select.options);

  if (value.includes(' / ')) {
    const options = value.split(' / ');

    options.forEach((value, index) => {
      const optionSelectorName = `SingleOptionSelector-${index}`;
      const select = document.querySelector(
        `select[name=${optionSelectorName}]`
      );

      if (!select) {
        return;
      }

      const selectOptions = select.querySelectorAll('option');
      selectOptions.forEach((option) => {
        if (option.value === value.trim()) {
          option.setAttribute('selected', 'selected');
        } else {
          option.removeAttribute('selected');
        }
      });

      const selectChange = new Event('change', {
        bubbles: true,
        cancelable: false,
      });

      select.dispatchEvent(selectChange);
    });
    document.dispatchEvent(
      new CustomEvent('variant-select-change', {
        detail: {
          savings: '$100',
        },
      })
    );
    return;
  }

  selectOptions.forEach((option) => {
    if (!option || !(option instanceof HTMLOptionElement)) {
      return;
    }
    if (overrideValue) {
      if (option.index === 0) {
        option.setAttribute('selected', 'selected');
      } else {
        option.removeAttribute('selected');
      }
    } else {
      if (option.value === value) {
        select.value = value;
        option.setAttribute('selected', 'selected');
      } else {
        option.removeAttribute('selected');
      }
    }
  });

  const selectElement = selectOptions[0]?.parentNode;

  if (!(selectElement instanceof HTMLSelectElement)) {
    return;
  }

  const selectChange = new Event('change', {
    bubbles: true,
    cancelable: false,
  });

  selectElement.dispatchEvent(selectChange);
};

export const updateValueOfHiddenSelectBoxOnRadioChange = (): void => {
  document.addEventListener('change', (el) => {
    if (!el || !(el.target instanceof HTMLInputElement)) {
      return;
    }

    if (!el.target.matches('.product-form__item-radio input[type="radio"]')) {
      return;
    }

    const singleSelectName = el.target.dataset.singleSelector;
    if (!singleSelectName) {
      return;
    }

    maybeUpdateSingleSelectOptions(el.target.value, singleSelectName);
  });
};
